import script from "./Modify.vue?vue&type=script&setup=true&lang=ts"
export * from "./Modify.vue?vue&type=script&setup=true&lang=ts"

import "./Modify.vue?vue&type=style&index=0&id=0fc7e6a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fc7e6a8"]])

export default __exports__